import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ServiceTaskHistory } from './service-task-history';
export { ServiceTaskHistory };
import { serviceTaskHistorySchema } from '@schemas/business-objects/service-task-history';
import { ServiceTaskFormGroup } from './service-task-form-group';
import { TenantFormGroup } from './tenant-form-group';

export class ServiceTaskHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    serviceTaskId: SchemaFormControl;
    serviceTask: ServiceTaskFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<ServiceTaskHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(serviceTaskHistorySchema, ServiceTaskHistory, data, options);
  }

  get object(): ServiceTaskHistory {
    return new ServiceTaskHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'serviceTask':
        return new ServiceTaskFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ServiceTaskHistory[]> {
    return ServiceTaskHistory.find(filter);
  }

  static async findOne(filter?: any): Promise<ServiceTaskHistory | null> {
    return ServiceTaskHistory.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<ServiceTaskHistory> {
    return ServiceTaskHistory.findById(id, filter);
  }

  static async create(
    data: Partial<ServiceTaskHistory>,
  ): Promise<ServiceTaskHistory> {
    return ServiceTaskHistory.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ServiceTaskHistory>,
  ): Promise<ServiceTaskHistory> {
    return ServiceTaskHistory.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ServiceTaskHistory.deleteById(id);
  }
}

export class ServiceTaskHistoryFormArray extends PersistedFormArray {
  declare controls: ServiceTaskHistoryFormGroup[];

  readonly entityName = 'ServiceTaskHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(serviceTaskHistorySchema, ServiceTaskHistory, options);
  }

  protected override createItemGroup() {
    return new ServiceTaskHistoryFormGroup();
  }

  get array(): ServiceTaskHistory[] {
    return this.controls.map(
      (group: ServiceTaskHistoryFormGroup) => group.object,
    );
  }
}

export class ServiceTaskHistoryPersistedArray extends PersistedArray<ServiceTaskHistory> {
  readonly entityName = 'ServiceTaskHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ServiceTaskHistory, options);
  }
}
